// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b6f21080","605":"c2011cc1","840":"2d6e29a7","920":"faef1155","962":"af89a544"}[chunkId] + ".chunk.js";
};